<template>
  <div class="lv-add-member-card">
    <p class="lv-add-member-card_title">
      {{ title }}
    </p>
    <LvContentTabBar001
      :selected-tab-id="contentTabs.selectedTabId"
      :content-tabs="contentTabs.tabs"
      @click="$_onClickContentTab($event)"
    />
    <LlAddMemberInputList
      v-if="contentTabs.selectedTabId === 'single'"
      :role-list="roleList"
      :is-account-number-full="isAccountNumberFull"
      :scope-list="scopeList"
      :organization-factory-list="organizationFactoryList"
      :multipleSystemClassMenu="multipleSystemClassMenu"
      @add-member-next="$_onClickAddMember($event)"
      @no-scroll="$_onClickNoScroll()"
      @scroll="$_onClickScroll()"
      @add-open="$_onOpenAddPopup()"
      @btn-click="$_onClickBtn()"
    />
    <LvBatchAddMemberCard
      v-if="contentTabs.selectedTabId === 'batch'"
      :maxMemberCount="maxMemberCount"
      :memberCount="memberCount"
      @batch-create-success="$emit('batch-create-success')"
    />
  </div>
</template>
<script>
export default {
  props: {
    tableTitle: {
      type: Array,
      default() {
        return [];
      },
    },
    tableData: {
      type: Array,
      default() {
        return [];
      },
    },
    title: {
      type: String,
      default: '新增成員',
    },
    isAccountNumberFull: {
      type: Boolean,
      default: false,
    },
    roleList: {
      type: Array,
      default() {
        return [];
      },
    },
    scopeList: {
      type: Array,
      default() {
        return [];
      },
    },
    organizationFactoryList: {
      type: Array,
      default() {
        return [];
      },
    },
    multipleSystemClassMenu: {
      type: Array,
      default: undefined,
    },
    maxMemberCount: {
      type: Number,
    },
    memberCount: {
      type: Number,
    },
  },
  data() {
    return {
      contentTabs: {
        selectedTabId: 'single',
        tabs: [
          {
            id: 'single',
            textLabel: this.$t('單筆新增'),
            link: 'single',
          },
          {
            id: 'batch',
            textLabel: this.$t('批量新增'),
            link: 'batch',
          },
        ],
      },
    };
  },
  methods: {
    $_onClickContentTab(tab) {
      this.contentTabs.selectedTabId = tab.id;
    },
    $_onClickAddMember($event) {
      this.$emit('add-member-next', $event);
    },
    $_onOpenAddPopup() {
      this.$emit('add-open');
    },
    $_onClickNoScroll() {
      this.$emit('no-scroll');
    },
    $_onClickScroll() {
      this.$emit('scroll');
    },
    $_onClickBtn() {
      this.$emit('btn-click');
    },
  },
};
</script>
